import { TabbedSection, type SectionTab } from '../components/TabbedSection';

/**
 * Tab layouts for destinations that absorbed former top-level sidebar entries.
 * Each renders a tab bar over an <Outlet> for its child routes (wired in App.tsx).
 */

const DEVICE_TABS: SectionTab[] = [
  { to: '/devices', labelKey: 'nav.tabs.all', end: true },
  { to: '/devices/enrollment', labelKey: 'nav.tabs.enrollment' },
  { to: '/devices/pending', labelKey: 'nav.tabs.pending' },
  { to: '/devices/conflicts', labelKey: 'nav.tabs.conflicts' },
];

const ALERT_TABS: SectionTab[] = [
  { to: '/alerts', labelKey: 'nav.tabs.alerts', end: true },
  { to: '/alerts/rules', labelKey: 'nav.tabs.rules' },
];

const DEPLOYMENT_TABS: SectionTab[] = [
  { to: '/deployments', labelKey: 'nav.tabs.deployments', end: true },
  { to: '/deployments/revisions', labelKey: 'nav.tabs.revisions' },
];

export const DevicesSection = (): JSX.Element => <TabbedSection tabs={DEVICE_TABS} />;
export const AlertsSection = (): JSX.Element => <TabbedSection tabs={ALERT_TABS} />;
export const DeploymentsSection = (): JSX.Element => <TabbedSection tabs={DEPLOYMENT_TABS} />;
